import { useContext } from 'react'
import { Grid } from '@mui/material'
import { DataContext } from '../../../contexts/data/dataContext'
import EnergyFlowMessage from './energyFlowMessage';
import EnergyFlowDiagram from './energyFlowDiagram';
import custom from '../../../styles/mui/szVariables.json'

export default function EnergyFlow() {
  const data: any = useContext(DataContext)
  
  return (
    <Grid container id="energyFlowContent"
          display="flex"
          flexDirection={{
            xs: "column-reverse",
            sm: "row",
            md: "row",
            lg: "row"
          }}
          justifyContent={"center"} 
          alignContent={"center"}
          maxWidth="100%"
          mt={custom.spacing.lg}
          mb={custom.spacing.xl}
          >
        <Grid item xs={12} lg={6} 
              sm={data?.rightPanel?12:6} 
              md={data?.rightPanel?12:6} 
              display="flex" 
              justifyContent={"center"} 
              flexDirection={"column"}
              width="100%"
              px={custom.spacing.md}>
            <EnergyFlowMessage />
        </Grid>
        <Grid item xs={12} lg={6} 
              sm={data?.rightPanel?12:6} 
              md={data?.rightPanel?12:6}
              display="flex" 
              justifyContent={"center"} 
              flexDirection={"row"}  
              maxWidth="100%" 
              >
            <EnergyFlowDiagram />
        </Grid>
    </Grid>     
  )
}
